<template>
  <button
    :title="label"
    :aria-label="label"
    class="relative grid place-items-center rounded-xl transition-all duration-150 ease-smooth"
    :class="[sizeClass, variantClass]"
  >
    <slot />
    <span v-if="badge" class="absolute top-1.5 right-1.5 w-2 h-2 rounded-full bg-red-400 animate-pulse-dot" />
  </button>
</template>

<script setup>
import { computed } from 'vue';

const props = defineProps({
  label: String,
  size: { type: String, default: 'md' },
  variant: { type: String, default: 'ghost' },
  badge: Boolean,
});

const sizeClass = computed(() => ({
  sm: 'w-8 h-8 [&_svg]:w-3.5 [&_svg]:h-3.5',
  md: 'w-10 h-10 [&_svg]:w-4 [&_svg]:h-4',
  lg: 'w-11 h-11 [&_svg]:w-5 [&_svg]:h-5',
}[props.size]));

const variantClass = computed(() => ({
  ghost: 'bg-white/[.04] text-ink-2 border border-line-strong hover:text-ink hover:bg-white/[.08] hover:border-cyan',
  plain: 'bg-transparent text-muted hover:text-ink hover:bg-white/[.05]',
  grad: 'bg-grad text-slate-950 hover:shadow-glow',
}[props.variant]));
</script>
